<template>
    <div>
        <div class="row">
            <div class="col-sm-6">
                <div class="form-group">
                    <label><strong>Category</strong></label>
                    <select class="form-control" name="category_id" v-model="category_id" @change="getProductProperties()">
                        <option v-for="(category, index) in categories" :value="category.id">{{ category.name }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row d-none">
            <div class="col-sm-12">
                <div class="custom-control custom-checkbox my-2">
                    <label><strong></strong></label>
                    <input type="checkbox" class="custom-control-input" id="is_useful_link" name="is_useful_link" v-model="product.is_useful_link">
                    <label class="custom-control-label" for="is_useful_link">Display on useful links</label>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <div class="form-group">
                    <label><strong>Featureds</strong></label>
                    <multiselect
                        v-model="product.featured"
                        :options="pFeatured"
                        :multiple="true"
                        :close-on-select="true"
                        :clear-on-select="true" 
                        :preserve-search="false"
                        placeholder="Choose Featureds"
                        label="title" 
                        track-by="title">
                    </multiselect>
                    <input type="hidden" name="featured" :value="JSON.stringify(product.featured)">
                </div>
            </div>
        </div>
        <!-- Must have properties -->
        <slot></slot>
        
        <div class="row" v-for="(property, index) in productProperties" :key="index">
            <div class="col-sm-12">
                <div class="form-group">
                    <label><strong>{{ getName(property.name) }}</strong></label>
                    <input
                        v-if="property.type == 1"
                        :placeholder="getName(property.name)"
                        maxlength="255"
                        :name="property.name"
                        type="text" 
                        class="form-control"
                        v-model="product[`${property.name}`]"
                    >
                    <textarea
                        v-if="property.type == 2"
                        :placeholder="getName(property.name)"
                        maxlength="255"
                        :name="property.name"
                        rows="10"
                        class="form-control"
                        v-model="product[`${property.name}`]"
                    >
                    </textarea>
                    <editor 
                        v-if="property.type == 3"
                        :name="getName(property.name)"
                        :content="product[`${property.name}`]"
                        :input-name="`${property.name}`">
                    </editor>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ['pProductProperties', 'pProduct', 'pCategories', 'pFeatured'],
    data() {
        return {
            product: this.pProduct,
            productProperties: this.pProductProperties,
            categories: [],
            category_id: this.pProduct && this.pProduct.category ? this.pProduct.category.id : -1
        };
    },
    mounted() {
        this.initCategories();
    },
    methods: {
        initCategories() {
            _.forEach(this.pCategories, (category) => {
                this.categories = [...this.categories, category];
                _.forEach(category.children, (children) => {
                    children.name = '----- ' + children.name;
                    this.categories = [...this.categories, children];
                })
            });
        },
        getName(name) {
            return _.capitalize(_.replace(name, '_', ' '));
        },
        async getProductProperties() {
            const res = await axios.get(`/admin/get-product-properties/${this.category_id}`);
            if (res && res.status == 200) {
                this.productProperties = res.data.data;
            }
        }
    }
}
</script>
